import React from "react";
import Slider from "react-slick";
import moment from "moment-timezone";

const FilmDetail = (props) => {
  const settings = {
    customPaging: i => {
      return <a>{i + 1}</a>;
    },
    dots: true,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1
  };

  return (
    <React.Fragment>
      <div className="screening_top d_flex">
        <div className="d_flex">
          <div className="left_col">
            <Slider {...settings}>
              {props?.film?.filmId?.images.length > 0 && props?.film?.filmId?.images.map((image) => {
                return (
                  <div>
                    <div className="media_image">
                      <img src={   
                        image.inSite ? props.imageUrl + image.inSite : 
                          image.link ? image.link : 
                         '/images/image-placeholder.png'} alt="image" />
                    </div>
                  </div>
                );
              })}
            </Slider>
          </div>

        </div>
        <div className="screening_movie_desc screening_movie_sec">
          <div className="movie_category">
            <div>
              {props?.film?.filmId?.category && <p className="mt_10">{props?.film?.category?.filmId?.name}</p>}
              <h3 className="feature_title">{props?.film?.filmId?.title}</h3>
              <p className="editor_view" dangerouslySetInnerHTML={{ __html: props?.film?.filmId?.description }} />
              <div className="data_list">
                <ul>
                  {props?.film?.filmId?.year && <li className="d_flex">
                    <label>Year</label>
                    <span> {props?.film?.filmId?.year}</span>
                  </li>}
                  {props?.film?.filmId?.category && <li className="d_flex">
                    <label>Category</label>
                    <span> {props?.film?.filmId?.category?.name}</span>
                  </li>}
                  {props?.film?.filmId?.country && <li className="d_flex">
                    <label>Country</label>
                    <span> {props?.film?.filmId?.country}</span>
                  </li>}
                  {props?.film?.filmId?.runTime && <li className="d_flex">
                    <label>Run Time</label>
                    <span> {props?.film?.filmId?.runTime}</span>
                  </li>}
                  {props?.film?.filmId?.company && <li className="d_flex">
                    <label>Company</label>
                    <span> {props?.film?.filmId?.company}</span>
                  </li>}
                  {props?.film?.filmId?.website && <li className="d_flex">
                    <label>Website</label>
                    <span> {props?.film?.filmId?.website}</span>
                  </li>}
                  {props?.film?.filmId?.genre && <li className="d_flex">
                    <label>Genre</label>
                    <span>{props?.film?.filmId?.genre && props?.film?.filmId?.genre.map((item) => <p>{item.name}</p>)}
											  </span>
                  </li>}
                  {props?.film?.filmId?.interestTrack && <li className="d_flex">
                    <label>Interest Tracks</label>
                    <span>{props?.film?.filmId?.interestTrack && props?.film?.filmId?.interestTrack.map((item) => (
                      <p>{item.name}</p>
                    ))}
											</span>
                  </li>}
                  {props?.film?.filmId?.accessibility && <li className="d_flex">
                    <label>Accessibility</label>
                    <span>{props?.film?.filmId?.accessibility && props?.film?.filmId?.accessibility.map((item) => (
                      <p>{item.name}</p>
                    ))}
											</span>
                  </li>}
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="screening_dates_side">
          <p
            className="text_right mb_10">{moment(props?.film?.screeningDate).tz("US/Mountain").format("ddd")}, {moment(props?.film?.screeningDate).tz("US/Mountain").format("MMM DD")} - {moment(props?.film?.screeningDate).tz("US/Mountain").format("h:mm A")}</p>
          <div className="screen_dates">
            <div className="header_title">
              <h3>Screening Date - Time (MT)</h3>
            </div>
            <div className="screen_list">
              <ul>
                <li>
                  <p>{moment(props?.film?.screeningDate).tz("US/Mountain").format("dddd")}, {moment(props?.film?.screeningDate).tz("US/Mountain").format("MMM DD")} - {moment(props?.film?.screeningDate).tz("US/Mountain").format("h:mm A")}</p>
                </li>
              </ul>
            </div>
            <div className="text_right participate_row">
              <h4>Current active participants</h4>
              <h2>{props.userCount}</h2>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

FilmDetail.propTypes = {};

export default FilmDetail;